
import { defineComponent, PropType } from "vue";
import store from "@/store";
import PreschoolPerformancePeriodAssignmentsService from "@/api/Preschool/PreschoolPerformancePeriodAssignmentsService";
import PeriodsService from "@/api/Configuration/PeriodsService";
import PreschoolPerformancesService from "@/api/Preschool/PreschoolPerformancesService";
import type {
    IPreschoolPerformancePeriodAssignmentsModel,
    IPeriodsModel,
    IPreschoolPerformancesModel,
    IPreschoolDimensionsModel
} from "@/interfaces/modules";


export default defineComponent({
    name: "CompetencyPeriodAssignmentsTab",
    props: {
        dimension: {
            type: Object as PropType<IPreschoolDimensionsModel | null>,
            required: true,
        },
    },
    data() {
        return {
            saving: false,
            periods: [] as IPeriodsModel[],
            performances: [] as IPreschoolPerformancesModel[],
            form: {
                dialog: false,
                loading: false,
                record: {} as IPreschoolPerformancePeriodAssignmentsModel,
            },
            table: {
                filters: { search: "" },
                currentPage: 1,
                loading: false,
                headers: [
                    { key: "PeriodId", label: "Período", sortable: true },
                    { key: "PerformanceId", label: "Desempeño", sortable: true },
                    { key: "WeightPercent", label: "Peso %", sortable: true },
                    { key: "AssignedAt", label: "Fecha asignación", sortable: true },
                    { key: "CreatedByFormat", label: "Creación", sortable: true },
                    { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
                    { key: "action", label: "Acciones", sortable: false },
                ],
                records: [] as IPreschoolPerformancePeriodAssignmentsModel[],
                rowsPerPage: 10,
            } as any,
        };
    },
    async mounted() {
        await this.load();
    },
    computed: {
        filteredItems(): any {
            const q = this.table.filters.search?.toLowerCase() || "";
            return q
                ? this.table.records.filter((item: IPreschoolPerformancePeriodAssignmentsModel) =>
                    [item.PeriodName, item.PeriodId, item.WeightPercent]
                        .filter(Boolean)
                        .some((v) => String(v).toLowerCase().includes(q))
                )
                : this.table.records;
        },
        rows(): number {
            return this.table.records?.length || 0;
        },
    },
    methods: {
        async load() {
            this.form.loading = true;

            // Ajusta al método real
            this.periods = await PeriodsService.GetPeriods();
            let _records = await PreschoolPerformancePeriodAssignmentsService.GetAll();
            this.table.records = _records.filter(r => r.DimensionId === this.dimension?.Id);
            let _performances = await PreschoolPerformancesService.GetPreschoolPerformances();
            this.performances = _performances.filter((r) => r.DimensionId === this.dimension?.Id);
            this.form.loading = false;

        },
        openModal() {
            this.form.record = {
                Id: 0,
                PerformanceId: 0,
                DimensionId: this.dimension?.Id || 0,
                PeriodId: 0,
                WeightPercent: 0,
                AssignedAt: new Date().toISOString().substring(0, 10),
            } as IPreschoolPerformancePeriodAssignmentsModel;
            this.form.dialog = true;
        },
        async edit(data: IPreschoolPerformancePeriodAssignmentsModel) {
            this.form.record = await PreschoolPerformancePeriodAssignmentsService.GetById(data.Id);
            this.form.dialog = true;
        },
        async handleSubmit(event: Event) {
            event.preventDefault();

            this.saving = true;
            try {
                await PreschoolPerformancePeriodAssignmentsService.Post(
                    this.form.record as IPreschoolPerformancePeriodAssignmentsModel
                );
                this.form.dialog = false;
                this.saving = false;
                store.dispatch("core/popupDialog", {
                    text: "Registro completado con éxito.",
                    type: "success",
                    showCancelButton: false,
                });

                await this.load();
            } catch (err: any) {
                this.form.loading = false;
                this.saving = false;
                store.dispatch("core/popupDialog", {
                    text: `Error: ${err?.response?.data?.message || err?.message}`,
                    type: "error",
                    showCancelButton: false,
                });
            }

        },
    },
});
